// extracted by mini-css-extract-plugin
export default {"Item":"Selector-module__Item--FiaVl"};